import { render, staticRenderFns } from "./ListPathwayLeads.vue?vue&type=template&id=31b2cb8d&"
import script from "./ListPathwayLeads.vue?vue&type=script&lang=js&"
export * from "./ListPathwayLeads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports